import { Type } from 'typebox';
import { Attachment } from '../reference/attachment.js';
import { DailyReportEntry, DailyReportEntryTypes } from './daily-report-entry.js';
export const MediaEntry = Type.Evaluate(Type.Intersect([
    DailyReportEntry,
    Type.Object({
        typeName: Type.Literal(DailyReportEntryTypes.media),
        attachments: Type.Optional(Type.Array(Attachment)),
        pendingApproval: Type.Optional(Type.Boolean()),
        subjectKeys: Type.Optional(Type.Array(Type.String({ minLength: 1 })))
    })
]));
